module.exports = __webpack_public_path__ + "static/img/7.7123ae6.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/8/4/zh/7.png
// module id = 7Bb8
// module chunks = 0